@if (searchForm) {
  <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
    <div class="grid-3-columns gap-32">
      @if (shouldDisplayField('nhsNumber')) {
        <div class="nhsuk-form-group mb-0" [class.invalid]="searchForm.controls['nhsNumber'].errors && formSubmitted">
          <label class="nhsuk-label" for="nhs-number">NHS Number</label>
          <input
            class="nhsuk-input"
            [class]="{ 'not-empty': isNotEmpty('nhsNumber') }"
            id="nhs-number"
            name="nhs-number"
            type="text"
            formControlName="nhsNumber"
          />
          @if (searchForm.controls['nhsNumber'].errors && formSubmitted) {
            <ng-container>
              <span class="nhsuk-error-message" role="alert">
                <span class="nhsuk-u-visually-hidden">Error:</span>
                {{ searchForm.get('nhsNumber')?.errors?.['NHSnumber'] }}
              </span>
            </ng-container>
          }
        </div>
      }
      @if (shouldDisplayField('forename')) {
        <div class="nhsuk-form-group mb-0">
          <label class="nhsuk-label" for="forename">Forename</label>
          <input
            class="nhsuk-input"
            [class]="{ 'not-empty': isNotEmpty('forename') }"
            id="forename"
            name="forename"
            type="text"
            formControlName="forename"
          />
        </div>
      }
      @if (shouldDisplayField('surname')) {
        <div class="nhsuk-form-group mb-0">
          <label class="nhsuk-label" for="surname">Surname</label>
          <input
            class="nhsuk-input"
            [class]="{ 'not-empty': isNotEmpty('surname') }"
            id="surname"
            name="surname"
            type="text"
            formControlName="surname"
          />
        </div>
      }
      @if (shouldDisplayField('startDateDoB')) {
        <div
          class="nhsuk-form-group mb-0"
          [class.invalid]="searchForm.controls['startDateDoB'].errors && formSubmitted"
        >
          <label class="nhsuk-label" for="startDateDoB">Date of Birth</label>
          <input
            class="nhsuk-input"
            [class]="{ 'not-empty': isNotEmpty('startDateDoB') }"
            id="startDateDoB"
            name="startDateDoB"
            type="text"
            placeholder="dd/mm/yyyy"
            formControlName="startDateDoB"
          />
          @if (searchForm.controls['startDateDoB'].errors && formSubmitted) {
            <ng-container>
              <span class="nhsuk-error-message" role="alert">
                <span class="nhsuk-u-visually-hidden">Error:</span>
                The date format should be dd/mm/yyyy
              </span>
            </ng-container>
          }
        </div>
      }
      @if (shouldDisplayField('address')) {
        <div class="nhsuk-form-group mb-0">
          <label class="nhsuk-label" for="address">Address</label>
          <input
            class="nhsuk-input"
            [class]="{ 'not-empty': isNotEmpty('address') }"
            id="address"
            name="address"
            type="text"
            formControlName="address"
          />
        </div>
      }
      @if (shouldDisplayField('immunisationStatus')) {
        <div class="nhsuk-form-group mb-0">
          <label class="nhsuk-label" for="immunisationStatus"> Immunisation Status</label>
          <select
            class="nhsuk-select"
            [class]="{ 'not-empty': isNotEmpty('immunisationStatus') }"
            id="immunisationStatus"
            name="immunisationStatus"
            formControlName="immunisationStatus"
          >
            <option value="-1" selected>-- Choose a status --</option>
            <option value="NotFully">Not fully immunised</option>
            <option value="Fully">Fully immunised</option>
          </select>
        </div>
      }
      @if (shouldDisplayField('sex')) {
        <div class="nhsuk-form-group mb-0">
          <label class="nhsuk-label" for="sex">Sex</label>
          <select
            class="nhsuk-select"
            [class]="{ 'not-empty': isNotEmpty('sex') }"
            id="sex"
            name="sex"
            formControlName="sex"
          >
            <option value="-1" selected>-- Choose a Sex --</option>
            <option value="f">F</option>
            <option value="m">M</option>
          </select>
        </div>
      }
      @if (shouldDisplayField('englishFirstLanguage')) {
        <div class="nhsuk-form-group mb-0">
          <label class="nhsuk-label" for="englishFirstLanguage">English as first language</label>
          <select
            class="nhsuk-select"
            [class]="{ 'not-empty': isNotEmpty('englishFirstLanguage') }"
            id="englishFirstLanguage"
            name="englishFirstLanguage"
            formControlName="englishFirstLanguage"
          >
            <option value="-1" selected>-- Is English first language? --</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
      }
    </div>
    <br />
    <div class="flex gap-16">
      <button class="nhsuk-button" data-module="nhsuk-button" type="submit">Search</button>
      <button class="nhsuk-button nhsuk-button--secondary" type="button" (click)="clearFilters()">Clear filters</button>
    </div>
  </form>
}
